<template>
  <div class="progressBar">
    <!-- <div class="progressBar_visual" :style="{height: ancho}">
      <div class="progressBar_visual-hecho" :style="{width: `${progreso.wellPercentage}%`, height: ancho}"></div>
    </div>-->
    <div class="progressBar_visual" :style="{height: ancho}">
      <div
        v-if="progreso.wellPercentage"
        class="progressBar_visual-well"
        :style="{width: `${progreso.wellPercentage}%`, height: ancho}"
      >{{wellComp}} % ({{progreso.wellTotal}})</div>
      <div
        v-if="progreso.pendingPercentage"
        class="progressBar_visual-pending"
        :style="{width: `${progreso.pendingPercentage}%`, height: ancho}"
      >{{pendingComp}} % ({{progreso.pendingTotal}})</div>
      <div
        v-if="progreso.standbyPercentage"
        class="progressBar_visual-standby"
        :style="{width: `${progreso.standbyPercentage}%`, height: ancho}"
      >{{standbyComp}} % ({{progreso.standbyTotal}})</div>
      <div
        v-if="progreso.badPercentage"
        class="progressBar_visual-bad"
        :style="{width: `${progreso.badPercentage}%`, height: ancho}"
      >{{badComp}} % ({{progreso.badTotal}})</div>

      <!-- <div class="progressBar_visual-bad" :style="{width: `8%`, height: ancho}"></div> -->
    </div>
    <!-- <div class="progressBar_data">
      <div class="progressBar_data-hecho">
        <p>{{wellComp}} % ({{progreso.wellTotal}})</p>
        <p>Bien</p>
      </div>
      <div class="progressBar_data-falta">
        <p>{{badComp}} % ({{progreso.badTotal}})</p>
        <p>Mal</p>
      </div>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "progressBar",
  props: ["ancho", "progreso"],
  created() {
    //console.log(this.progreso);
  },
  computed: {
    falta: function() {
      return 100 - this.progreso.wellPercentage;
    },
    wellComp: function() {
      return this.progreso.wellPercentage.toFixed(2);
    },
    badComp: function() {
      return this.progreso.badPercentage.toFixed(2);
    },
    pendingComp: function() {
      return this.progreso.pendingPercentage.toFixed(2);
    },
    standbyComp: function() {
      return this.progreso.standbyPercentage.toFixed(2);
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/styles/1.settings/index";
.progressBar {
  width: 100%;
  // padding: 10px;
}
.progressBar_visual,
.progressBar_data {
  width: 100%;
  display: flex;
  align-items: center;
}
.progressBar_visual {
  justify-content: stretch;
  border-radius: 5px;
  overflow: hidden;
  // background-color: $colorReportNeutral;
  &-well,
  &-bad,
  &-pending,
  &-standby {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 50px;
    font-weight: bold;
  }
}
.progressBar_data {
  width: 100%;
  justify-content: space-between;
  margin: 10px 0;
  font-size: 18px;
  font-weight: bolder;
  line-height: 1;
}
.progressBar_visual-well {
  padding: 0;
  margin: 0;
  background-color: $colorReportGood;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  color: #ffffff;
}
.progressBar_visual-bad {
  padding: 0;
  margin: 0;
  background-color: $colorReportBad;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  color: #ffffff;
}
.progressBar_visual-pending {
  padding: 0;
  margin: 0;
  background-color: $colorReportNeutral;
  color: #ffffff;
}
.progressBar_visual-standby {
  padding: 0;
  margin: 0;
  background-color: gray;
  color: #ffffff;
}
.progressBar_data-hecho {
  color: $colorReportGood;
}
.progressBar_data-falta {
  color: $colorReportBad;
}
</style>



// WEBPACK FOOTER //
// src/components/Componentes/progressBar.vue